<template>
    <div id="otpPage" class="text-center">
        <v-card class="pa-10" v-if="loading">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
        </v-card>
        <v-card :disabled="otpLoading" v-if="!loading" style="width: 90%; max-width: 500px;" class="pa-10" rounded="xl">
            <Logo width="128px" :height="'128px'" theme="light" />
            <h3 class="font-weight-bold">منصة نور التعليمية</h3>
            <template v-if="screen === 'send'">
                <div class="my-5">لتتمكن من المتابعة, سنقوم بارسال رمز التحقق الى رقمك من خلال رسالة WhatApp</div>
                <v-btn color="success" prepend-icon="mdi-whatsapp" text="ارسال رمز التحقق" @click="sendOtp"
                    :loading="resendLoading"></v-btn>
            </template>
            <template v-if="screen === 'check'">
                <small>التحقق بخطوتين</small>
                <p class="mt-5">تم ارسال رمز التحقق الى الرقم <b>{{ userInfo.phone }}</b></p>
                <v-otp-input dir="ltr" @finish="checkOtp()" v-model="otp" length="6"></v-otp-input>
            </template>
        </v-card>
        <div class="text-white mt-5 loginCopyrights">
            <b>Nooor Educational Platform v{{ require('../../package.json').version }}</b>
            <br>
            <b>Nooor.app &copy; {{ new Date().getFullYear() }}</b>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        loading: true,
        otp: '',
        userInfo: null,
        otpLoading: false,
        resendLoading: false,
        screen: 'send',
    }),
    methods: {
        async fetch() {
            this.loading = true;
            this.userInfo = (await this.$axios.get('users/me')).data['data'];
            this.loading = false;
        },
        async sendOtp() {
            this.resendLoading = true;
            await this.$axios.post("accounts/otp", {
                phone: this.userInfo.phone,
            });
            this.screen = 'check';
            this.resendLoading = false;
            this.$toast.success("تم ارسال رمز التحقق بنجاح");
        },
        async checkOtp() {
            this.otpLoading = true;
            try {
                await this.$axios.post("accounts/check-otp", {
                    phone: this.userInfo.phone,
                    otp: this.otp,
                });
                await this.$axios.patch("users/me", {
                    last_otp: new Date(),
                });
                this.$toast.success("تم التحقق بنجاح");
                window.location.reload();
            } catch (error) {
                this.$toast.error("رمز التحقق غير صحيح");
            } finally {
                this.otpLoading = false;
            }
        }

    },
    mounted() {
        this.fetch();
    },
}
</script>

<style scoped>
#otpPage {
    background-color: rgb(var(--v-theme-info));
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

}
</style>